import React from 'react';
import * as Styles from "./foot.css";

const Foot = (props) => {
    return (
        <Styles.FootWrapper>
            <Styles.FootColumn>
                <div className="container">
                    <Styles.CardGrid>
                        <Styles.Card >
                            <Styles.PorblemHeader>
                                Lorem Ipsium Now
                            </Styles.PorblemHeader>
                            <Styles.ProblemDescription>
                                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et !
                            </Styles.ProblemDescription>
                        </Styles.Card>
                        <Styles.Card bg={'blue'} >
                            <Styles.PorblemHeader>
                                Lorem Ipsium Now
                            </Styles.PorblemHeader>
                            <Styles.ProblemDescription>
                                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et !
                            </Styles.ProblemDescription>
                        </Styles.Card>
                    </Styles.CardGrid>
                    
                </div>
            </Styles.FootColumn>
        </Styles.FootWrapper>
    );
}
export default Foot;